// extracted by mini-css-extract-plugin
export default {"popoverContent":"EditNotePopover_popoverContent__Zn0BD","col-cells-resources":"EditNotePopover_col-cells-resources__QctH1"};